import { call, put, select, takeEvery } from 'redux-saga/effects';
import { SET_LOCAL_SAE_REPORT, SAVE_LOCAL_SAE, GET_LOCAL_SAE, SUBMIT_LOCAL_SAE } from 'store/key';
import { produce } from 'utility/general';
import { setGlobalLoading } from 'store/global/reducer';
import API from 'api/call';
import { safeSaga } from 'store';
import store from 'store';
import { setGlobal } from 'store/global/reducer';
import { statusLookup } from 'utility/lookup';

const initialState = {
    reportData: null,
    remoteDetail: {
        addSupplements: [],
        deleteSupplements: [],
        actualStudyStartDate: null,
        isNotYetStarted: null,
        recruitedSubjectNo: null,
        expiryDate: null,
        nameOfStudySite: null,
        subjectOutcome: null,
        causeOfDeath: null,
        subjectRefCode: null,
        subjectRefInitials: null,
        subjectRefSex: null,
        subjectRefAge: null,
        relevantMedicalHistory: null,
        natureOfSae: null,
        saeStartDate: null,
        saeStopDate: null,
        saeNotResolved: null,
        typeOfSae: null,
        frequency: null,
        isDeath: null,
        isLiftThreatening: null,
        isSignificantDisability: null,
        isRequiredHospitalization: null,
        isPersisentDisability: null,
        isProlongedHospitalization: null,
        isCongenitalAnomaly: null,
        isNone: null,
        isOther: null,
        suspectedRelationship: null,
        affectedSubjectNone: null,
        affectedSubjectAdjustedDosage: null,
        affectedSubjectInterrupt: null,
        affectedSubjectDiscontinued: null,
        alterationRequired: null,
        recommendation: null,
    },
    rows: [],
    remoteDocIds: [],
    isLoading: false,
    forceErrorDisplay: false,
    oldData: {
        actualStudyStartDate: null,
        isNotYetStarted: null,
        recruitedSubjectNo: null,
        expiryDate: null,
        nameOfStudySite: null,
        subjectOutcome: null,
        causeOfDeath: null,
        subjectRefCode: null,
        subjectRefInitials: null,
        subjectRefSex: null,
        subjectRefAge: null,
        relevantMedicalHistory: null,
        natureOfSae: null,
        saeStartDate: null,
        saeStopDate: null,
        saeNotResolved: null,
        typeOfSae: null,
        frequency: null,
        isDeath: null,
        isLiftThreatening: null,
        isSignificantDisability: null,
        isRequiredHospitalization: null,
        isPersisentDisability: null,
        isProlongedHospitalization: null,
        isCongenitalAnomaly: null,
        isNone: null,
        isOther: null,
        suspectedRelationship: null,
        affectedSubjectNone: null,
        affectedSubjectAdjustedDosage: null,
        affectedSubjectInterrupt: null,
        affectedSubjectDiscontinued: null,
        alterationRequired: null,
        recommendation: null,
    },
};

function* getLocalSAE(action) {
    const { docType, reportId, appId, isFormCreate, siteId, onPermissionError } = action.payload;
    const { localSAEReport } = yield select();
    localSAEReport.isLoading = true;
    localSAEReport.forceErrorDisplay = false;

    yield put({
        type: SET_LOCAL_SAE_REPORT,
        payload: localSAEReport,
    });

    try {
        let data = { docType: docType, siteId };
        if (isFormCreate) {
            data.appId = appId;
            data.reportId = null;
        } else {
            data.reportId = reportId;
        }

        const res = yield call(API.postApprovalActivities.getReportDetail, data);
        const detail = res.data.result;
        localSAEReport.remoteDetail = detail;
        localSAEReport.remoteDetail.addSupplements = [];
        localSAEReport.remoteDetail.deleteSupplements = [];
        localSAEReport.rows = detail.supplementDocuments ?? [];
        localSAEReport.remoteDocIds = detail.supplementDocuments?.map((item) => item.id) ?? [];

        Object.keys(localSAEReport.oldData).forEach((key) => {
            localSAEReport.oldData[key] = detail[key];
        });

        if (!isFormCreate) {
            let subNo = null,
                statusDisplay = null;
            if (detail.subNo) {
                subNo = detail.subNo;
            }
            if (detail.lastStatus !== null) {
                statusDisplay =
                    statusLookup.find((item) => {
                        return detail.lastStatus === item.key;
                    })?.statusDisplay || null;
            }
            store.dispatch(
                setGlobal({
                    postApprovalReportData: {
                        [reportId]: {
                            showNavigationSubNo: subNo,
                            showNavigationStatus: statusDisplay,
                        },
                    },
                }),
            );
        }
    } catch (error) {
        console.log('get localSAE report detail failed:', error);
        return onPermissionError?.();
    }

    localSAEReport.isLoading = false;
    yield put({
        type: SET_LOCAL_SAE_REPORT,
        payload: localSAEReport,
    });
}

function* saveLocalSAE(action) {
    const { callback, reportId, appId, isFormCreate, signedFileId, siteId } = action.payload;
    const { localSAEReport } = yield select();

    setGlobalLoading(true);
    try {
        const {
            actualStudyStartDate,
            isNotYetStarted,
            recruitedSubjectNo,
            addSupplements,
            deleteSupplements,
            expiryDate,
            nameOfStudySite,
            subjectOutcome,
            causeOfDeath,
            subjectRefCode,
            subjectRefInitials,
            subjectRefSex,
            subjectRefAge,
            relevantMedicalHistory,
            natureOfSae,
            saeStartDate,
            saeStopDate,
            saeNotResolved,
            typeOfSae,
            frequency,
            isDeath,
            isLiftThreatening,
            isSignificantDisability,
            isRequiredHospitalization,
            isPersisentDisability,
            isProlongedHospitalization,
            isCongenitalAnomaly,
            isNone,
            isOther,
            suspectedRelationship,
            affectedSubjectNone,
            affectedSubjectAdjustedDosage,
            affectedSubjectInterrupt,
            affectedSubjectDiscontinued,
            alterationRequired,
            recommendation,
        } = localSAEReport.remoteDetail;

        let data = {
            actualStudyStartDate: actualStudyStartDate ? new Date(actualStudyStartDate) : null,
            isNotYetStarted,
            recruitedSubjectNo,
            addSupplements,
            deleteSupplements,
            appId: appId ?? localSAEReport.remoteDetail.appId,
            signedFileId,
            siteId,
            expiryDate,
            nameOfStudySite,
            subjectOutcome,
            causeOfDeath,
            subjectRefCode,
            subjectRefInitials,
            subjectRefSex,
            subjectRefAge,
            relevantMedicalHistory,
            natureOfSae,
            saeStartDate,
            saeStopDate,
            saeNotResolved,
            typeOfSae,
            frequency,
            isDeath,
            isLiftThreatening,
            isSignificantDisability,
            isRequiredHospitalization,
            isPersisentDisability,
            isProlongedHospitalization,
            isCongenitalAnomaly,
            isNone,
            isOther,
            suspectedRelationship,
            affectedSubjectNone,
            affectedSubjectAdjustedDosage,
            affectedSubjectInterrupt,
            affectedSubjectDiscontinued,
            alterationRequired,
            recommendation,
        };

        if (!isFormCreate) {
            data.reportId = reportId;
        }

        const res = yield call(API.localSAEReport.saveLocalSAE, data);

        const newReportId = res.data.result.reportId;
        callback?.(newReportId);
    } catch (error) {
        console.log('create/save localSAE failed:', error);
    }
    setGlobalLoading(false);
}

function* submitLocalSAE(action) {
    const { callback, reportId, appId, isFormCreate, signedFileId, siteId } = action.payload;
    const { localSAEReport } = yield select();

    setGlobalLoading(true);
    try {
        const {
            actualStudyStartDate,
            isNotYetStarted,
            recruitedSubjectNo,
            addSupplements,
            deleteSupplements,
            expiryDate,
            nameOfStudySite,
            subjectOutcome,
            causeOfDeath,
            subjectRefCode,
            subjectRefInitials,
            subjectRefSex,
            subjectRefAge,
            relevantMedicalHistory,
            natureOfSae,
            saeStartDate,
            saeStopDate,
            saeNotResolved,
            typeOfSae,
            frequency,
            isDeath,
            isLiftThreatening,
            isSignificantDisability,
            isRequiredHospitalization,
            isPersisentDisability,
            isProlongedHospitalization,
            isCongenitalAnomaly,
            isNone,
            isOther,
            suspectedRelationship,
            affectedSubjectNone,
            affectedSubjectAdjustedDosage,
            affectedSubjectInterrupt,
            affectedSubjectDiscontinued,
            alterationRequired,
            recommendation,
        } = localSAEReport.remoteDetail;

        let data = {
            actualStudyStartDate: actualStudyStartDate ? new Date(actualStudyStartDate) : null,
            isNotYetStarted,
            recruitedSubjectNo,
            addSupplements,
            deleteSupplements,
            appId: appId ?? localSAEReport.remoteDetail.appId,
            signedFileId,
            expiryDate,
            nameOfStudySite,
            subjectOutcome,
            causeOfDeath,
            subjectRefCode,
            subjectRefInitials,
            subjectRefSex,
            subjectRefAge,
            relevantMedicalHistory,
            natureOfSae,
            saeStartDate,
            saeStopDate,
            saeNotResolved,
            typeOfSae,
            frequency,
            isDeath,
            isLiftThreatening,
            isSignificantDisability,
            isRequiredHospitalization,
            isPersisentDisability,
            isProlongedHospitalization,
            isCongenitalAnomaly,
            isNone,
            isOther,
            suspectedRelationship,
            affectedSubjectNone,
            affectedSubjectAdjustedDosage,
            affectedSubjectInterrupt,
            affectedSubjectDiscontinued,
            alterationRequired,
            recommendation,
        };

        if (!isFormCreate) {
            data.reportId = reportId;
        } else {
            data.siteId = siteId;
        }

        try {
            const response = yield call(API.localSAEReport.submitLocalSAE, data);
            if (response.status === 400) {
                throw new Error('Bad Request: The server returned a 400 status.');
            }
            callback?.();
        } catch (error) {
            console.log('submit localSAE failed:', error);
            throw error; // Re-throw the error if needed
        }

        callback?.();
    } catch (error) {
        console.log('submit localSAE failed:', error);
    }
    setGlobalLoading(false);
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_LOCAL_SAE_REPORT:
            const newState = produce(state, (draft) => {
                Object.entries(action.payload).forEach(([key, value]) => {
                    draft[key] = action.payload[key];
                });
            });
            return newState;
        default:
            return state;
    }
};
export function* watchLocalSAEReport() {
    yield takeEvery(GET_LOCAL_SAE, safeSaga(getLocalSAE));
    yield takeEvery(SAVE_LOCAL_SAE, safeSaga(saveLocalSAE));
    yield takeEvery(SUBMIT_LOCAL_SAE, safeSaga(submitLocalSAE));
}

export default reducer;
